import React from 'react';
import './Filtros.css';

const Filtros = ({ categories, onFilterSelect }) => {
  return (
    <div className="filtros">
      <h5>Todos los productos</h5>
      <ul>
        {categories.map((category, index) => (
          <li key={index} onClick={() => onFilterSelect(category)}>
            {category}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Filtros;